/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_SendInputs */

const th_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งคำเชิญ`)
};

const en_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invitations`)
};

const ja_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待を送る`)
};

const zh_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送邀请`)
};

const es_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar invitaciones`)
};

const pt_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar convites`)
};

const id_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim undangan`)
};

const fr_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer les invitations`)
};

const tl_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipadala ang mga paanyaya`)
};

const vi_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lời mời`)
};

const ko_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 보내기`)
};

const de_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen senden`)
};

const ru_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить приглашения`)
};

const tr_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davetleri gönder`)
};

const it_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia gli inviti`)
};

const pl_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij zaproszenia`)
};

const uk_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати запрошення`)
};

const hi_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण भेजें`)
};

const ar_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال الدعوات`)
};

const ms_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar jemputan`)
};

const bn_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ পাঠান`)
};

const zh_tw2_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出邀請`)
};

const zh_hk2_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出邀請`)
};

const ur_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوتیں بھیجیں`)
};

const fa_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرستادن دعوت‌ها`)
};

const sw_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma mialiko`)
};

const nl_meeting_send = /** @type {(inputs: Meeting_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingen versturen`)
};

/**
* | output |
* | --- |
* | "Send invitations" |
*
* @param {Meeting_SendInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_send = /** @type {((inputs?: Meeting_SendInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_SendInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_send(inputs)
	if (locale === "ja") return ja_meeting_send(inputs)
	if (locale === "zh") return zh_meeting_send(inputs)
	if (locale === "es") return es_meeting_send(inputs)
	if (locale === "pt") return pt_meeting_send(inputs)
	if (locale === "id") return id_meeting_send(inputs)
	if (locale === "fr") return fr_meeting_send(inputs)
	if (locale === "tl") return tl_meeting_send(inputs)
	if (locale === "vi") return vi_meeting_send(inputs)
	if (locale === "ko") return ko_meeting_send(inputs)
	if (locale === "de") return de_meeting_send(inputs)
	if (locale === "ru") return ru_meeting_send(inputs)
	if (locale === "tr") return tr_meeting_send(inputs)
	if (locale === "it") return it_meeting_send(inputs)
	if (locale === "pl") return pl_meeting_send(inputs)
	if (locale === "uk") return uk_meeting_send(inputs)
	if (locale === "hi") return hi_meeting_send(inputs)
	if (locale === "ar") return ar_meeting_send(inputs)
	if (locale === "ms") return ms_meeting_send(inputs)
	if (locale === "bn") return bn_meeting_send(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_send(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_send(inputs)
	if (locale === "ur") return ur_meeting_send(inputs)
	if (locale === "fa") return fa_meeting_send(inputs)
	if (locale === "sw") return sw_meeting_send(inputs)
	if (locale === "nl") return nl_meeting_send(inputs)
	return en_meeting_send(inputs)
});